import { render, staticRenderFns } from "./WorkspaceActionCards.vue?vue&type=template&id=2ac422f3&scoped=true"
import script from "./WorkspaceActionCards.vue?vue&type=script&lang=ts"
export * from "./WorkspaceActionCards.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceActionCards.vue?vue&type=style&index=0&id=2ac422f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac422f3",
  null
  
)

export default component.exports